/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { ApolloProvider } from 'react-apollo'
import createClient from './create-client'

export default ({ element }, options) => <ApolloProvider client={createClient(options.endpointUrl)}>{element}</ApolloProvider>
